import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPerlComponent } from './simple-icons-perl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPerlComponent ],
    exports:      [ SimpleIconsPerlComponent ],
    bootstrap:    []
})
export class SimpleIconsPerlModule {}
